import { IAPIRoutes } from "../../../../config";

export type IBillingRepository = ReturnType<typeof BillingRepositoryFactory>;

export const BillingRepositoryFactory = ({
  APIProvider,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT, POST, DELETE } = APIProvider;

  /**
   * Payers
   */
  const GetPayers: IGetBillingPayers = async (params) => {
    if ("apiName" in params) {
      delete params.apiName;
    }
    return GET(APIRoutes.apiGetBillingPayers, params) as Promise<
      PaginatedListResponse<IGetBillingPayersResponse>
    >;
  };

  const UpdatePayer: IUpdateBillingPayer = async (payload) => {
    const { id, created_at, updated_at, ...bodyData } = payload;

    return PUT(
      APIRoutes.apiUpdateBillingPayer.replace("{id}", String(id)),
      bodyData
    );
  };

  const CreatePayer: ICreateBillingPayer = async (payload) => {
    return POST(APIRoutes.apiCreateBillingPayer, payload);
  };

  const DeletePayer: IDeleteBillingPayer = async (id) => {
    return DELETE(APIRoutes.apiDeleteBillingPayer.replace("{id}", String(id)));
  };

  /**
   * Providers
   */
  const GetProviders: IGetBillingProviders = async (params) => {
    if ("apiName" in params) {
      delete params.apiName;
    }
    return GET(APIRoutes.apiGetBillingProviders, params) as Promise<
      PaginatedListResponse<IGetBillingProvidersResponse>
    >;
  };

  const UpdateProvider: IUpdateBillingProvider = async (payload) => {
    const { id, created_at, updated_at, ...bodyData } = payload;

    return PUT(
      APIRoutes.apiUpdateBillingProvider.replace("{id}", String(id)),
      bodyData
    );
  };

  const CreateProvider: ICreateBillingProvider = async (payload) => {
    return POST(APIRoutes.apiCreateBillingProvider, payload);
  };

  const DeleteProvider: IDeleteBillingProvider = async (id) => {
    return DELETE(
      APIRoutes.apiDeleteBillingProvider.replace("{id}", String(id))
    );
  };

  /**
   * Entity
   */
  const GetEntities: IGetBillingEntity = async (payload) => {
    const params = payload;
    return GET(APIRoutes.apiGetBillingEntity, params) as Promise<{
      success: boolean;
      data: IGetBillingEntityResponse;
    }>;
  };

  const UpdateEntity: IUpdateBillingEntity = async (payload) => {
    const { id, created_at, updated_at, ...bodyData } = payload;

    return PUT(
      APIRoutes.apiUpdateBillingEntity.replace("{id}", String(id)),
      bodyData
    );
  };

  const CreateEntity: ICreateBillingEntity = async (payload) => {
    return POST(APIRoutes.apiCreateBillingEntity, payload);
  };

  const DeleteEntity: IDeleteBillingEntity = async (id) => {
    return DELETE(APIRoutes.apiDeleteBillingEntity.replace("{id}", String(id)));
  };

  /**
   * Rosters
   */
  const GetRosters: IGetBillingRoster = async (params) => {
    if ("apiName" in params) {
      delete params.apiName;
    }
    return GET(APIRoutes.apiGetBillingRosters, params) as Promise<
      PaginatedListResponse<IGetBillingRosterResponse>
    >;
  };

  const UpdateRoster: IUpdateBillingRoster = async (payload) => {
    const { id, created_at, updated_at, ...bodyData } = payload;

    return PUT(
      APIRoutes.apiUpdateBillingRoster.replace("{id}", String(id)),
      bodyData
    );
  };

  const CreateRoster: ICreateBillingRoster = async (payload) => {
    return POST(APIRoutes.apiCreateBillingRoster, payload);
  };
  const DeleteRoster: IDeleteBillingRoster = async (id) => {
    return DELETE(APIRoutes.apiDeleteBillingRoster.replace("{id}", String(id)));
  };

  return {
    GetPayers,
    UpdatePayer,
    CreatePayer,
    DeletePayer,

    GetProviders,
    UpdateProvider,
    CreateProvider,
    DeleteProvider,

    GetEntities,
    UpdateEntity,
    CreateEntity,
    DeleteEntity,

    GetRosters,
    UpdateRoster,
    CreateRoster,
    DeleteRoster,
  };
};
